import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {UserAddressOptionDto, UserProfileDto} from '../../../models/generated-models';

@Injectable({providedIn: 'root'})
export class UserProfileService {
  private readonly http = inject(HttpClient);

  getPersonalProfile(): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>(`${environment.serverUrl}/api/users/profile/personal`);
  }

  savePersonalProfile(profile: UserProfileDto): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>(`${environment.serverUrl}/api/users/profile/personal`, profile);
  }

  uploadProfileAvatar(file: File): Observable<UserProfileDto> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<UserProfileDto>(`${environment.serverUrl}/api/users/profile/avatar`, form);
  }

  searchAddresses(search: string, limit = 10): Observable<UserAddressOptionDto[]> {
    return this.http.get<UserAddressOptionDto[]>(`${environment.serverUrl}/api/users/address-options`, {
      params: {search, limit}
    });
  }
}
